import { createStore } from 'vuex'
import type { AuthUser } from '@/types/auth'

export interface State {
  user: AuthUser | null
  userTeamIds: number[]
}

// sessionStorage é limpo pelo navegador ao fechar a aba/janela (mas sobrevive
// a um F5) — usado em main.ts pra distinguir "recarregou a página" de "fechou
// o navegador/aba" e forçar logout só no segundo caso. Ver checkStaleSession.
export const SESSION_ACTIVE_KEY = 'wootdash_session_active'

export default createStore<State>({
  state: {
    user: null,
    userTeamIds: [],
  },
  getters: {
    isLoggedIn:  (s) => !!s.user?.access_token,
    isAdmin:     (s) => s.user?.role === 'administrator',
    authUser:    (s) => s.user,
    userTeamIds: (s) => s.userTeamIds,
  },
  mutations: {
    SET_USER(state, user: AuthUser | null) {
      state.user = user
      if (user) {
        localStorage.setItem('auth_user', JSON.stringify(user))
        try { sessionStorage.setItem(SESSION_ACTIVE_KEY, '1') } catch { /* modo privado etc. */ }
      } else {
        localStorage.removeItem('auth_user'); localStorage.removeItem('auth_team_ids')
        try { sessionStorage.removeItem(SESSION_ACTIVE_KEY) } catch { /* ignore */ }
      }
    },
    SET_TEAM_IDS(state, ids: number[]) {
      state.userTeamIds = ids
      if (ids.length) localStorage.setItem('auth_team_ids', JSON.stringify(ids))
      else localStorage.removeItem('auth_team_ids')
    },
  },
  actions: {
    login({ commit }, user: AuthUser) { commit('SET_USER', user) },
    logout({ commit }) { commit('SET_USER', null); commit('SET_TEAM_IDS', []) },
    setUserTeams({ commit }, ids: number[]) { commit('SET_TEAM_IDS', ids) },
    restoreSession({ commit }) {
      try {
        const u = localStorage.getItem('auth_user')
        if (u) commit('SET_USER', JSON.parse(u))
        const t = localStorage.getItem('auth_team_ids')
        if (t) commit('SET_TEAM_IDS', JSON.parse(t))
      } catch { /* ignore corrupt storage */ }
    },
  },
})
